import React from 'react';

import { LOYALTY_PALETTES } from '../../../utils';
import { LoyaltyTerms } from '../../LoyaltyTerms';
import { LoyaltyHomeHowItWorks } from '../LoyaltyHomeHowItWorks';

// ─────────────────────────────────────────────────────────────────────────────

export const LoyaltyHomeHowItWorksSection = (props: Props) => {
  const { entries, disclaimer, isPremium, termsAndConditionsUrl, onTermsLinkPress } = props;

  // ─── Derived ───────────────────────────────────────────────────────────────

  const palette = isPremium ? 'dark' : 'light';

  return (
    <LoyaltyHomeHowItWorks.Container palette={palette}>
      <LoyaltyHomeHowItWorks.Content>
        {entries.map((entry, index) => (
          <LoyaltyHomeHowItWorks.Card
            index={index + 1}
            key={entry.title}
            title={entry.title}
            description={entry.description}
            image={entry.image}
            palette={palette}
          />
        ))}
      </LoyaltyHomeHowItWorks.Content>

      {disclaimer ? (
        <LoyaltyHomeHowItWorks.Disclaimer palette={palette}>
          {disclaimer}
        </LoyaltyHomeHowItWorks.Disclaimer>
      ) : undefined}

      <LoyaltyTerms
        palette="light"
        style={isPremium ? LOYALTY_PALETTES.premiumFgColor : undefined}
        termsAndConditionsUrl={termsAndConditionsUrl}
        onLinkPress={onTermsLinkPress}
      />
    </LoyaltyHomeHowItWorks.Container>
  );
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  entries: Entry[];
  disclaimer?: string;
  isPremium: boolean;
  termsAndConditionsUrl: string;
  onTermsLinkPress: () => void;
};

type Entry = {
  title: string;
  description: string;
  image?: string;
};
